import CataloniaForm from './components/CataloniaForm';

export default {
  chainSlug: 'catalonia-test',
  forms: [{ component: CataloniaForm, form: 'CataloniaCheckinGuest', after: null, hiddenFooter: true }],
};
